import classNames from 'classnames';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import * as styles from './index.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger';

const variantStyles: Record<ButtonVariant, string> = {
    primary: styles.btnPrimary,
    secondary: styles.btnSecondary,
    danger: styles.btnDanger,
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: ButtonVariant;
    children: ReactNode;
};

export function Button({ variant = 'primary', type = 'button', className, children, ...props }: ButtonProps) {
    return (
        <button type={type} className={classNames(variantStyles[variant], className)} {...props}>
            {children}
        </button>
    );
}
